import React from 'react'
import './styles.css'
import { useLocalState } from '../../shared/UseLocalState'
import { authState } from '../../state/Auth.state'
import { Person } from '../../api'
import { actualShowState } from '../../state/ActualShow.state'
import { ShowDto } from '../../types/ShowDto'
import { formatDate } from '../../shared/format-date'

interface NavigationProps {
  loggedIn: boolean
  linkClicked: () => void
}

export const Navigation = ({ loggedIn, linkClicked }: NavigationProps) => {
  const user = useLocalState<Person | null>(authState.user$, authState.user$.value)
  const database = user?.database
  const actualShow = useLocalState<ShowDto | undefined>(actualShowState.actualShow$, actualShowState.actualShow$.value)

  return (
    <nav style={{ zIndex: 1000 }}>
      <div className='nav-container'>
        {loggedIn && (
          <>
            <a href='#/home' className='nav-link' onClick={linkClicked}>
              Startseite
            </a>
            <a href='#/registration' className='nav-link' onClick={linkClicked}>
              Online-Nennung
            </a>
            <a href='#/address-change' className='nav-link' onClick={linkClicked}>
              Adressänderung
            </a>
            <a href='#/horses' className='nav-link' onClick={linkClicked}>
              Pferd registrieren
            </a>
            <a href='#/person-register' className='nav-link' onClick={linkClicked}>
              Person registrieren
            </a>
          </>
        )}
              {/**/} <a href='#/history' className='nav-link' onClick={linkClicked}>
          IGV Datenbank
        </a> 
        <a href='mailto:nennung.turnier@igv-online.de' className='nav-link'>
          Kontakt
        </a>
        <a href='https://IGV-online.de/hilfe-zur-online-nennung/' target='_blank' className='nav-link'>
          Hilfe
        </a>
        {loggedIn && actualShow && (
          <div className='nav-show-info'>
            <p className='nav-show-name'>
              {actualShow.name}
              {actualShow.announcementLink && (
                <>
                  {' '}
                  <a
                    href={actualShow.announcementLink}
                    target='_blank'
                    rel='noreferrer'
                    className='nav-show-link'
                  >
                    Ausschreibung
                  </a>
                </>
              )}
            </p>
            {actualShow.location && <p>{actualShow.location}</p>}
            {actualShow.city && <p>{actualShow.city}</p>}
            {actualShow.startDate && actualShow.endDate && (
              <p>
                {formatDate(actualShow.startDate)} – {formatDate(actualShow.endDate)}
              </p>
            )}
            {actualShow.deadlineDate && (
              <p>Stichtag: {formatDate(actualShow.deadlineDate)}</p>
            )}
          </div>
        )}
        {loggedIn && user && (
          <div className='nav-show-info'>
            <p>{user.firstName} {user.lastName}</p>
            {user.member && <p>Mitglied: {user.member}</p>}
            {user.youthStatus != null && user.youthStatus > 0 && (
              <p>{user.youthStatus === 1 ? 'Jugend A' : user.youthStatus === 2 ? 'Jugend B' : ''}</p>
            )}
            <p>{user.leisureStatus ? 'Freizeitreiter' : 'Sportreiter'}</p>
          </div>
        )}
      </div>
      <div className='nav-footer' style={database && database !== 'hmdat' ? { backgroundColor: 'orange', color: '#000' } : undefined}>
              &copy; 2026 JK &amp; JT.<br />
        {database && <span style={{ marginLeft: '1rem', opacity: 0.6, fontSize: '0.8em' }}>{database}</span>}
      </div>
    </nav>
  )
}
